var _ellipse, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.03,
    cy: 28,
    rx: 27.03,
    ry: 28,
    fill: "#A19F9D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1877_3060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1314 27.6668H21.9774L29.3973 20.2135L27.5125 18.3335L16.8936 29.0002L27.5125 39.6668L29.384 37.7868L21.9774 30.3335H38.1314V27.6668Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1877_3060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.8567,
    height: 32,
    fill: "white",
    transform: "translate(11.584 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4ebaee86f6a23b755684afe2fb029baf.svg";
export { ForwardRef as ReactComponent };